


































import {Component, Vue} from 'vue-property-decorator';
import PhoneSelect from '@/components/ui/PhoneSelect.vue';

@Component({
	components: {
		'v-phone-select': PhoneSelect
	}
})
export default class OpenAccount extends Vue {
	isSend: boolean = false;
}
